import { render, staticRenderFns } from "./FormCard.vue?vue&type=template&id=71e2b565&scoped=true"
import script from "./FormCard.vue?vue&type=script&lang=js"
export * from "./FormCard.vue?vue&type=script&lang=js"
import style0 from "./FormCard.vue?vue&type=style&index=0&id=71e2b565&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e2b565",
  null
  
)

export default component.exports